import React from 'react';

import { JuridictionAdminResponseDto } from 'lib_api/lib/api/gen';

import TableQuery from 'components/WrappedComponents/Table/TableQuery/TableQuery';
import { ColumnProps } from 'components/WrappedComponents/Table/types';
import { JuridictionSort } from 'enums/referentiels/Juridiction';
import { useDashboardSearchQuery } from 'hooks/search/useDashboardSearchQuery';
import { useSearchJuridictionQuery } from 'hooks/search/useSearchJuridictionQuery';
import { typeJuridictionMapping } from 'utils/enumData';
import { DEFAULT_PAGE_SIZE_OPTIONS } from 'utils/global';

import DashboardHeader from './DashboardHeader/DashboardHeader';
import CellDetailsAndActions from './CellDetailsAndActions';

function buildColumns(
  refreshDashboard: () => void,
): ColumnProps<JuridictionAdminResponseDto, JuridictionSort>[] {
  return [
    {
      title: 'Libellé',
      buildCellContent: data => data.libelle,
      sortedField: 'LIBELLE',
    },
    {
      title: 'Type',
      buildCellContent: data => typeJuridictionMapping[data.type],
      sortedField: 'TYPE',
    },
    {
      title: 'Numéro',
      buildCellContent: data => data.numero,
      sortedField: 'NUMERO',
    },
    {
      title: 'Origine',
      buildCellContent: data => data.origineElement,
      sortedField: 'ORIGINE_ELEMENT',
    },
    {
      title: 'Code postal',
      buildCellContent: data => data.codePostal,
      sortedField: 'CODE_POSTAL',
    },
    {
      title: 'Juridiction parente',
      buildCellContent: data => data.idCorrelationJuridictionParent,
    },
    {
      title: '',
      buildCellContent: data => (
        <CellDetailsAndActions
          juridiction={data}
          refreshDashboard={refreshDashboard}
        />
      ),
    },
  ];
}

function DashboardJuridiction(): React.ReactElement {
  const queryKeyLabel = 'paginationAdministrationJuridictions';
  const { query, filter, setFilter, sort, setSort, pagination, setPagination } =
    useDashboardSearchQuery(
      useSearchJuridictionQuery,
      queryKeyLabel,
      { valid: true },
      {},
      'paginationAdministrationJuridictions',
    );

  const refreshDashboard = () => {
    setFilter({ ...filter });
    void query.refetch();
  };

  return (
    <div className="table-container">
      <TableQuery
        columns={buildColumns(refreshDashboard)}
        queryKeyLabel={queryKeyLabel}
        query={query}
        buildItemKey={juridiction => juridiction.id}
        header={(fetchedData, _selectedData, filter, setFilter) => (
          <DashboardHeader
            totalCount={fetchedData?.total || 0}
            filter={filter}
            setFilter={setFilter}
            refreshDashboard={refreshDashboard}
          />
        )}
        filter={filter}
        setFilter={setFilter}
        pageSizeOptions={DEFAULT_PAGE_SIZE_OPTIONS}
        pagination={pagination}
        setPagination={setPagination}
        sort={sort}
        setSort={setSort}
      />
    </div>
  );
}

export default DashboardJuridiction;
